import type { FloorPlanIconsDTO } from '@/types/dto/agent';
import { decodeBase64SVG } from '@/utils/color';
import type { HSLString } from '@fleet/design-tokens';
import { useEffect, useState } from 'react';

interface UsePlaceElementOptions {
  typeId?: string;
  backgroundColor: HSLString;
  outlineColor: HSLString;
  floorPlanIcons: FloorPlanIconsDTO | undefined;
}

export const usePlaceElement = ({
  typeId,
  backgroundColor,
  outlineColor,
  floorPlanIcons,
}: UsePlaceElementOptions) => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  useEffect(() => {
    const loadImage = async () => {
      const icon = floorPlanIcons?.floorPlanIcons?.find((icon) =>
        typeId === 'PLACE_TYPE.BERTH'
          ? icon.subTypeId === 'PLACE_SUB_TYPE.BED1'
          : icon.typeId === typeId
      );
      const iconBase64String = icon?.icon?.split(',')[1];

      if (!iconBase64String) {
        return null;
      }

      const decodedSvg = decodeBase64SVG(
        iconBase64String,
        backgroundColor,
        outlineColor
      );

      const dataUrl = `data:image/svg+xml;base64,${decodedSvg}`;

      const img = new window.Image();
      img.onload = () => setImage(img);
      img.src = dataUrl;
    };

    loadImage();
  }, [typeId, backgroundColor, outlineColor, floorPlanIcons?.floorPlanIcons]);

  return {
    image,
  };
};

export default usePlaceElement;
